// alternative-dashboard\mappers\topBeneficiariesDataSource.ts
import { getQuarterDateRange } from "./topBeneficiariesDateHelper";
import type {
  TopBenificiariesGraphData,
  TopBenificiariesGraphResponse,
} from "../types/topBeneficiaries";
import type { ApiResponse } from "@/app/apiConfig/services/ApiResponse";
import { gxDashboardTopBeneficiariesGraphApi } from "@/app/apiConfig/services/paymentsAbstractApiLayer";

export const fetchTopBeneficiariesGraph = async (
  beneficiaryIds?: number[],
): Promise<ApiResponse<TopBenificiariesGraphResponse[]>> => {
  const { startDate, endDate } = getQuarterDateRange();

  const payload: TopBenificiariesGraphData = {
    startDate,
    endDate,
    ...(beneficiaryIds ? { beneficiaryIds } : {}),
  };

  return gxDashboardTopBeneficiariesGraphApi(payload) as unknown as Promise<
    ApiResponse<TopBenificiariesGraphResponse[]>
  >;
};
